(ns com.theplantscape.plant-web.draw.db-store
  (:require
   [cljs.reader]
   [clojure.string :as str]
   [com.theplantscape.local-store.ensemble
    :refer [diag
            fetch-diagram-id
            fetch-diagram-settings
            load-database
            reset-database
            set-diagram-id
            set-diagram-properties]]
   [com.theplantscape.plant-web.api.diagrams
    :refer [fetch-user-diagram store-users-diagram]]
   [com.theplantscape.plant-web.api.user :as api]
   [com.theplantscape.plant-web.draw.db :refer [register-queries]]
   [com.theplantscape.plant-web.draw.state :refer [app-state]]
   [datascript.core :as d]
   [reagent.dom.server :refer [render-to-string]]))

(defn un-ns-map [m] (update-keys m (comp keyword name)))
(defn ns-map [ns m] (update-keys m (comp (partial keyword ns) name)))
(defn ns-map-js [ns m] (update-keys m (comp keyword (partial str ns "|") name)))

(defn store-diagram
  [conn diagram]
  (prn "store database")
  (api/store-diagram (render-to-string diagram #_[ui-svg-diagram 600 600])))

(defn keyword-str [k]
  (subs (str k) 1))

(defn keyname [key] (str (namespace key) "/" (name key)))

(defn filter-diagram-atoms
  "We only want to save the plants and actual objects in the remote db"
  [[entity-id attribute value]]
  (or
   (str/starts-with? attribute  "plant/")
   (str/starts-with? attribute  "diagram.object/")
   #_(str/starts-with? attribute  "diagram.settings/")))

(defn store-database
  [conn]
  (prn "store database id " (str (fetch-diagram-id)))
  (prn (fetch-diagram-settings))
  (store-users-diagram
   {:xt/id (fetch-diagram-id)
    :settings (ns-map-js "diagram" (fetch-diagram-settings))
    ;; we need to fix the data to transfer over json
    :db (->> (d/datoms @diag :eavt)
             (mapv (comp vec seq))
             (mapv #(update % 1 keyword-str))
             (filter filter-diagram-atoms))}
   (fn store-remote-diagram [resp]
     (prn "Save users diagram remote")))

  ;(api/store-diagram   (render-to-string diagram #_[ui-svg-diagram 600 600]))
  ;(api/save-diagram {:body  (render-to-string [ui-svg-diagram 600 600])})
  (js/localStorage.setItem "db" (pr-str @conn)))

(defn restore-remote-diagram [conn diagram-id resp]
      (reset-database)
      (prn "restored db from remote")
      (when (:diagram/db resp)
        (load-database (:diagram/db resp))
        ;; this should not be needed but the stored version under db/diagram is in
        ;; a wierd format need to investigate
        (set-diagram-id diagram-id #_(str (:xt/id resp)))
        (prn "restored db from remote complete")
        ;; disabled causing looping currently
        (d/transact! conn [{:restore :local}])
        (register-queries)
        (prn "restored database id " (fetch-diagram-id))
        ;(reset! diag (cljs.reader/read-string (:diagram/db resp)))
        #_(prn @diag)
        #_(d/transact! diag [resp]))

      (set-diagram-properties
       {#_:xt/id #_(str "509e7938-3a72-4d47-a6c9-903cfe163b45")
        :xt/id (:xt/id resp) #_(str (parse-uuid (:xt/id resp)))
        :diagram.settings/public (or (:diagram/public resp) false)
        :diagram.settings/title (or (:diagram/title resp) "Untitled design")
        :diagram.settings/geo-location (or (:diagram/geo-location resp) [51.505 51.505])
        :diagram.settings/width (or (:diagram/width resp) "200")
        :diagram.settings/height (or (:diagram/height resp) "200")})
      (fetch-diagram-settings)
      (swap! app-state assoc-in [:diagram :settings :values] (fetch-diagram-settings))

      (prn "Restore Load users diagram remote"))

(defn restore-database
  ([conn] (restore-database conn (fetch-diagram-id)))
  ([conn diagram]
   (prn "restore diagram id " diagram)
   (fetch-user-diagram
    diagram
    (partial restore-remote-diagram conn diagram)
    #_(fn restore-remote-diagram [resp]
      (reset-database)
      (prn "restored db from remote")
      (prn resp)
      (prn (:xt/id resp))

      (when (:diagram/db resp)
        (load-database (:diagram/db resp))
        ;; this should not be needed but the stored version under db/diagram is in
        ;; a wierd format need to investigate
        (set-diagram-id diagram #_(str (:xt/id resp)))
        (prn "restored db from remote complete")
        ;; disabled causing looping currently
        (d/transact! conn [{:restore :local}])
        (register-queries)
        (prn "restored database id " (fetch-diagram-id))
        ;(reset! diag (cljs.reader/read-string (:diagram/db resp)))
        #_(prn @diag)
        #_(d/transact! diag [resp]))

      (set-diagram-properties
       {#_:xt/id #_(str "509e7938-3a72-4d47-a6c9-903cfe163b45")
        :xt/id (:xt/id resp) #_(str (parse-uuid (:xt/id resp)))
        :diagram.settings/public (or (:diagram/public resp) false)
        :diagram.settings/title (or (:diagram/title resp) "Untitled design")
        :diagram.settings/geo-location (or (:diagram/geo-location resp) [51.505 51.505])
        :diagram.settings/width (or (:diagram/width resp) "200")
        :diagram.settings/height (or (:diagram/height resp) "200")})
      (fetch-diagram-settings)
      (swap! app-state assoc-in [:diagram :settings :values] (fetch-diagram-settings))

      (prn "Restore Load users diagram remote")))

   #_(when (js/localStorage.getItem "db")
       (reset! conn (cljs.reader/read-string (js/localStorage.getItem "db")))
       (register-queries)
       (try
       ;; trigger a transact to make things reload
         (d/transact! conn [{:restore :local}])
         (register-queries)
         (prn "restored local db")
         (prn (d/datoms @diag :eavt))
         (catch js/Error e
           (.log js/console "Failed to restore local database"))))
   ;;(swap! app-state assoc-in [:diagram :eid] (fetch-or-create-diagram-eid))
   ))

(comment
  (fetch-user-diagram
   "459c0538-c275-4979-b4ca-3990cad5633c"
   (fn restore-remote-diagram [resp]
     (prn (:diagram/db resp))
     (reset! diag (cljs.reader/read-string (:diagram/db resp)))
     (d/transact! diag (cljs.reader/read-string (:diagram/db resp)))
     (prn "Load users diagram remote")))

  (d/transact! diag [{:restore :local}])

  (set-diagram-properties {:xt/id (str "309e7938-3a72-4d47-a6c9-903cfe163b45") #_(str (parse-uuid (:xt/id resp)))
                           :diagram.settings/title "test"
                           :diagram.settings/width "200"})
  (prn (set-diagram-id "309e7938-3a72-4d47-a6c9-903cfe163b45"))
  (prn (fetch-diagram-id))

  (d/datoms @diag :eavt)
  (d/conn-from-datoms datoms)

  (fetch-user-diagram
   "7a310ac5-6176-4484-a335-4d41a9458913"
   (fn restore-remote-diagram [resp]
     (prn resp)
     (d/transact! diag [resp])
     (prn "Load users diagram remote"))))
